import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QnSbnEserviceComponent } from './features/qn-sbn-eservice/qn-sbn-eservice.component';
import { NotificationComponent } from './features/qn-sbn-eservice/notification/notification.component';
import { NotificationDetailsComponent } from './features/qn-sbn-eservice/notification/notification-details/notification-details.component';
import { UniqueIdDialogComponent } from './features/qn-sbn-eservice/notification/unique-id-dialog/unique-id-dialog.component';
import { DueDateReminderComponent } from './features/qn-sbn-eservice/create-notification/due-date-reminder/due-date-reminder.component';
import { ConfigureFeedbackComponent } from './features/qn-sbn-eservice/create-notification/configure-feedback/configure-feedback.component';
import { MessageAttachmentComponent } from './features/qn-sbn-eservice/create-notification/message-attachment/message-attachment.component';
import { NotificationDocComponent } from './features/qn-sbn-eservice/create-notification/notification-doc/notification-doc.component';
import { NotificationTitleComponent } from './features/qn-sbn-eservice/create-notification/notification-title/notification-title.component';
import { CreateNotificationComponent } from './features/qn-sbn-eservice/create-notification/create-notification.component';
import { RecipientsListComponent } from './features/qn-sbn-eservice/create-notification/recipientslist/recipients-list/recipients-list.component';
import { ContactDetailsComponent } from './features/qn-sbn-eservice/notification/contact-details/contact-details.component';
import { AccountDetailsComponent } from './features/qn-sbn-eservice/notification/account-details/account-details.component';
import { EmailDeliveryComponent } from './features/qn-sbn-eservice/email-delivery/email-delivery.component';
import { DashboardComponent } from './features/qn-sbn-eservice/dashboard/dashboard.component';
import { DailySummaryReportComponent } from './features/qn-sbn-eservice/create-notification/daily-summary-report/daily-summary-report.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: '/notification',
    pathMatch: 'full'
  },
  {
    path: 'qnsbn-eservice',
    component: QnSbnEserviceComponent,
  
  },
  {
    path: 'notification',
    component: NotificationComponent,
    data: { trackWithAnalytics: true }
  },
  {
    path: 'notification-details',
    component: NotificationDetailsComponent,
    data: { trackWithAnalytics: true }
  },
  {
    path: 'create-local-notification',
    component: UniqueIdDialogComponent,
    data: { trackWithAnalytics: true }
  },
   {
    path: 'contact-details',
    component: ContactDetailsComponent,
    data: { trackWithAnalytics: true }
  },
  {
    path: 'account-details',
    component: AccountDetailsComponent,
    data: { trackWithAnalytics: true }
  },
  {
    path: 'create-notification',
    component: CreateNotificationComponent,
   
    data: { trackWithAnalytics: true },
    // loadChildren: () => import('./features/qn-sbn-eservices/create-notification/create-notification.module').then(m => m.CreateNotificationModule)
    children: [
      {
        path: '',
        redirectTo: 'notification-title',
        pathMatch: 'full'
      },
      {
        path: 'notification-title',
        component: NotificationTitleComponent,
       
        data: { trackWithAnalytics: true }
      },
      {
        path: 'notification-doc',
        component: NotificationDocComponent,
       
        data: { trackWithAnalytics: true }
      },
      {
        path: 'recipients',
        component: RecipientsListComponent,
       
        data: { trackWithAnalytics: true }
      },
      {
        path: 'message-attachment',
        component: MessageAttachmentComponent,
       
        data: { trackWithAnalytics: true }
      }, 
      {
        path: 'configure-feedback',
        component: ConfigureFeedbackComponent,
       
        data: { trackWithAnalytics: true }
      },
      {
        path: 'due-date-reminder',
        component: DueDateReminderComponent,
       
        data: { trackWithAnalytics: true }
      },
       {
        path: 'daily-summary-report',
        component: DailySummaryReportComponent,
        data: { trackWithAnalytics: true }
      },
      {
        path: '**',
        redirectTo: '/notification-title',
        pathMatch: 'full'
      }
    ]
  },
   {
    path: 'email-delivery',
    component: EmailDeliveryComponent,
    data: { trackWithAnalytics: true }
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    data: { trackWithAnalytics: true }
  },
  {
    path: 'email-delivery',
    component: EmailDeliveryComponent,
    data: { trackWithAnalytics: true }
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    data: { trackWithAnalytics: true }
  },
  {
    path: '**',
    redirectTo: '/notification',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
